import { useForm as createUseForm } from "@ant-design-vue/use";
import { notification, Modal } from "ant-design-vue";
import lodash from "lodash";
import { setIsLoading as setIsLoadingApp } from "../../../app.logic";
import { openModal as openModalOtp } from "../../../components/verify-otp/verify-otp.logic";
import { openModalForm as openModalFormCheckProfile } from "../modal/modal-check-register.logic";
import i18n from "../../../i18n";
import store from "../../../store";
import { initUseForm, watchRulesChildren } from "../../../utils/form";
import { createLoading } from "../../../utils/loading";
import {
    email,
    requiredWhen,
    required,
    hasIdCard,
    hasIdCardInUserRequest,
    sameWhen,
    validateError,
    thPid,
    thPidFirstCharacter,
    equalsLength,
} from "../../../utils/validate";
import { callAddressType, createForm as createFormAddress } from "../../../components/address/address.logic";
import { createForm as createFormUser } from "../../app/setting/user-mgt/user/user.logic";
import { callGender, callPersonType, callRegisterAttachment, callSameAddressType } from "../register/register.section";
import { createConditionForm } from "./register-fisherman.condition";
import { createField } from "./register-fisherman.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/userRequest";

export const callUserRegisterFisherman = ({ form }) => store.dispatch(`resource/v1/transaction/userRequest/RegisterFisherman`, { data: form });
export const callCheckIdTax = ({ idTax }) => store.dispatch("resource/v1/security/user/checkIdTax", { idTax, config: { isNotification: false } });
export const callCheckIdCardSystem = ({ form }) =>
    store.dispatch("resource/v1/security/user/checkIdCardSystem", { data: form, config: { isNotification: false } });
export const callAppToggleOtp = () => store.dispatch(`resource/v1/security/appProperty/toggleOtp`, { config: { isNotification: false } });

export const onClickSave = ({ data, formParams, otp, isWaitApprove }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callUserRegisterFisherman({ form: { userRequest: { ...data.useForm.modelRef, ...formParams }, otp, isWaitApprove } })
                .finally(() => setIsLoadingApp(false))
                .then(() => {
                    const emailInp = data.useForm?.modelRef?.email;
                    const emailShow = emailInp?.replace(emailInp?.substr(1), "xxx@xxxx");
                    data.lastPageImg = require(`../../../assets/icon/checked.svg`);
                    data.lastPageDetail = ["1"].includes(data.useForm.modelRef.refPersonType.key)
                        ? i18n.global.t("model.register.fisherman.lastPageResponse.detail1", { email: emailShow })
                        : i18n.global.t("model.register.fisherman.lastPageResponse.detail2");
                    data.current++;
                });
        })
        .catch((error) => {
            if (["1"].includes(data.useForm.modelRef.refPersonType.key)) {
                data.current++;
            }
            validateError({ error });
            data.lastPageImg = require(`../../../assets/icon/error_red_icon.svg`);
            data.lastPageDetail = i18n.global.t("model.register.fisherman.lastPageResponse.detailError");
            throw error;
        });
};

export const onNextRegister = ({ props, data, refs }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const rules0 = createRulesTab0({ props, data, refs });
    const rules1 = createRulesTab1({ props, data, refs });
    const rules3 = createRulesTab3({ props, data, refs });
    switch (data.current) {
        case 0:
            if ("1" === modelRef.refPersonType?.key) {
                lodash.remove(modelRef.attachmentIdCards, (d) => !d.id);
                modelRef.attachmentIdCards.forEach((d) => (d.isDelete = true));
                lodash.remove(modelRef.attachmentSignatures, (d) => !d.id);
                modelRef.attachmentSignatures.forEach((d) => (d.isDelete = true));
            }

            return data.useForm
                .validate(Object.keys(rules0))
                .then(() => {
                    modelRef.acceptCondition = false;
                    data.current++;
                })
                .catch(() => {
                    if (modelRef.refPersonType?.key === "1") {
                        if (data.useForm?.validateInfos?.userCorporateCommittees?.validateStatus === "error") {
                            data.tabKey = "UserSyndicate";
                        } else {
                            data.tabKey = "Attachment";
                        }
                    }
                });
        case 1:
            return data.useForm.validate(Object.keys(rules1)).then(() =>
                openModalFormCheckProfile({
                    props: { dataProp: { form: data.useForm.modelRef } },
                    onOk: () => {
                        setIsLoadingApp(true);
                        let promise = Promise.resolve(null);
                        if (["1"].includes(modelRef.refPersonType?.key)) {
                            promise = callCheckIdTax({ idTax: modelRef.idCard })
                                .then((res) => {
                                    setIsLoadingApp(false);
                                    if (!res) return null;
                                    const resultList = res?.ResultList?.[0];
                                    return {
                                        idCard: resultList.JuristicID,
                                        companyNameTh: resultList.JuristicName_TH,
                                        companyType: resultList.JuristicType,
                                        registerCapital: resultList.RegisterCapital,
                                        registerDate: resultList.RegisterDate,
                                    };
                                })
                                .catch(() => {
                                    data.linkIdCard = "wait";
                                    data.isWaitApprove = true;
                                });
                        } else if (["2"].includes(modelRef.refPersonType?.key)) {
                            promise = callCheckIdCardSystem({ form: data.useForm.modelRef })
                                .then((res) => {
                                    setIsLoadingApp(false);
                                    if (!res) return null;
                                    return {
                                        firstNameTh: res.firstNameTh,
                                        idCard: res.idCard,
                                        lastNameTh: res.lastNameTh,
                                        birthDate: res.birthDate,
                                        expireDate: res.expireDate,
                                        title: res.title,
                                    };
                                })
                                .catch(() => {
                                    data.linkIdCard = "wait";
                                    data.isWaitApprove = true;
                                });
                            lodash.remove(modelRef.attachments, (d) => !d.id);
                            modelRef.attachments.forEach((d) => (d.isDelete = true));
                        }
                        promise
                            .then((d) => {
                                if(d) {
                                    data.linkIdCard = d;
                                }
                                if("1" === modelRef.refPersonType?.key){
                                    if (!d) {
                                        data.linkIdCard = "wait";
                                        data.isWaitApprove = true;
                                    }
                                }
                            })
                            .finally(() => {
                                setIsLoadingApp(false);
                                data.current++;
                            });
                    },
                })
            );
        case 2:
            if ((nextPageChecklinkIdCardPersonType2({ data }) && ["2"].includes(modelRef.refPersonType?.key))) {
                return data.current++;
            } else if ((nextPageChecklinkIdCardPersonType1({ data }) && ["1"].includes(modelRef.refPersonType?.key))) {
                return Modal.confirm({
                    title: i18n.global.t("views.register.validateRegister"),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        return onClickSave({ props, data, refs }).then(() => {
                            notification["success"]({ message: i18n.global.t("views.register.success") });
                        });
                    },
                });
            }
            return notification["error"]({ message: i18n.global.t("views.register.fieldIdCardNotMatch") });
        case 3:
            Promise.all([callAppToggleOtp({})]).then((arr) => {
                data.toggleOtp = arr[0];
                if ("true" === data?.toggleOtp?.value) {
                    return data.useForm
                        .validate(Object.keys(rules3))
                        .then(() => onClickOpenModalOtp({ props, data, refs }))
                        .catch(() => {
                            notification["error"]({ message: i18n.global.t("views.register.requiredAttachments") });
                        });
                }
                return onClickSave({ props, data, refs, otp:{ mobile:modelRef.mobile } }).then(() => {
                    notification["success"]({ message: i18n.global.t("views.register.success") });
                });
            }).catch(() => {
                return onClickSave({ props, data, refs, otp:{ mobile:modelRef.mobile } }).then(() => {
                    notification["success"]({ message: i18n.global.t("views.register.success") });
                });
            });
           
           
    }
};

export const onPrevRegister = ({ data }) => {
    if (data.current != 0) {
        if (data.current <= 2) {
            data.linkIdCard = null;
        }
        data.current--;
    }
};

export const createForm = ({ props, data, refs }) => {
    return {
        ...createFormUser({ props, data, refs }),
        addresses: [createFormAddress(), createFormAddress()],
        acceptCondition: null,
    };
};

export const createRules = ({ props, data, refs, key }) => {
    return {
        ...createRulesTab0({ props, data, refs, key }),
        ...createRulesTab1({ props, data, refs, key }),
        ...createRulesTab3({ props, data, refs, key }),
    };
};

export const createRulesTab0 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refPersonType`]: [required],
        [`${prefix}refCompanyType`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}companyNameTh`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}registerCapital`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}registerDate`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}shareholdingTh`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}idCard`]: [
            required,
            requiredWhen({
                when: () => "1" != model.refPersonType?.key,
                requiredValidator: ({ rule, value }) => {
                    return thPid.validator(rule, value);
                },
            }),
            requiredWhen({
                when: () => "1" != model.refPersonType?.key,
                requiredValidator: ({ rule, value }) => {
                    return thPidFirstCharacter.validator(rule, value);
                },
            }),
            requiredWhen({
                when: () => "1" === model.refPersonType?.key,
                requiredValidator: ({ rule, value }) => {
                    return hasIdCard({
                        when: () => {
                            const { useForm } = data;
                            const { modelRef } = useForm;
                            const model = key ? lodash.get(modelRef, key) : modelRef;
                            return model.idCard;
                        },
                        refPersonType: i18n.global.t("error.form.hasIdCard.company")
                    }).validator(rule, value);
                },
            }),
            requiredWhen({
                when: () => "1" != model.refPersonType?.key,
                requiredValidator: ({ rule, value }) => {
                    return hasIdCard({
                        when: () => {
                            const { useForm } = data;
                            const { modelRef } = useForm;
                            const model = key ? lodash.get(modelRef, key) : modelRef;
                            return model.idCard;
                        },
                        refPersonType: i18n.global.t("error.form.hasIdCard.person")
                    }).validator(rule, value);
                },
            }),
            requiredWhen({
                when: () => "1" === model.refPersonType?.key,
                requiredValidator: ({ rule, value }) => {
                    return hasIdCardInUserRequest({
                        when: () => {
                            const { useForm } = data;
                            const { modelRef } = useForm;
                            const model = key ? lodash.get(modelRef, key) : modelRef;
                            return model.idCard;
                        },
                        refPersonType: i18n.global.t("error.form.hasIdCardUserRequest.company")
                    }).validator(rule, value);
                },
            }),
            requiredWhen({
                when: () => "1" != model.refPersonType?.key,
                requiredValidator: ({ rule, value }) => {
                    return hasIdCardInUserRequest({
                        when: () => {
                            const { useForm } = data;
                            const { modelRef } = useForm;
                            const model = key ? lodash.get(modelRef, key) : modelRef;
                            return model.idCard;
                        },
                        refPersonType: i18n.global.t("error.form.hasIdCardUserRequest.person")
                    }).validator(rule, value);
                },
            }),
        ],
        [`${prefix}birthDate`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}expireDate`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refNationality`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refRace`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refGender`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refTitle`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}firstNameTh`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}lastNameTh`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refEducation`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refMainOccupation`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refSecondOccupation`]: [requiredWhen({ when: () => model.refPersonType?.key === "2" })],
        [`${prefix}refSameAddressType`]: [required],
        [`${prefix}mobile`]: [required, equalsLength(10)],
        [`${prefix}email`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" }), email],
        [`${prefix}userCorporateCommittees`]: [requiredWhen({ when: () => model.refPersonType?.key === "1" })],
        [`${prefix}password`]: [required],
        [`${prefix}passwordConfirm`]: [
            required,
            sameWhen({
                when: () => {
                    const { useForm } = data;
                    const { modelRef } = useForm;
                    const model = key ? lodash.get(modelRef, key) : modelRef;
                    return model.password === model.passwordConfirm;
                },
                keyLabel: i18n.global.t("model.user.password"),
                sameLabel: i18n.global.t("model.user.passwordConfirm"),
            }),
        ],
    };
    if (model.refPersonType?.key === "1") {
        model?.attachments?.forEach((item, index) => {
            if (item.isDelete !== true) {
                rules[`${prefix}attachments.${index}.documentName`] = [required];
                rules[`${prefix}attachments.${index}.size`] = [
                    requiredWhen({ when: () => model.attachments[index].attribute?.isRequiredAttachment }),
                ];
            }
        });
    }
    model?.addresses?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}addresses.${index}.refAddressType`] = [required];
            rules[`${prefix}addresses.${index}.noTh`] = [required];
            rules[`${prefix}addresses.${index}.soiTh`] = [required];
            rules[`${prefix}addresses.${index}.roadTh`] = [required];
            rules[`${prefix}addresses.${index}.mooTh`] = [requiredWhen({ when: () => model?.addresses[index]?.refProvince?.code !== "10" })];
            rules[`${prefix}addresses.${index}.refProvince`] = [required];
            rules[`${prefix}addresses.${index}.refAmphur`] = [required];
            rules[`${prefix}addresses.${index}.refTambon`] = [required];
            rules[`${prefix}addresses.${index}.postCode`] = [required];
        }
    });
    return rules;
};

export const createRulesTab1 = ({ key }) => {
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}acceptCondition`]: [
            {
                validator: (rule, value) => {
                    if (value !== true) {
                        return Promise.reject(i18n.global.t("error.form.acceptCondition"));
                    }
                    return Promise.resolve();
                },
                trigger: "change",
            },
        ],
    };
    return rules;
};

export const createRulesTab3 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.attachmentIdCards?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}attachmentIdCards.${index}`] = [requiredWhen({ when: () => model.refPersonType?.key === "2" })];
            rules[`${prefix}attachmentIdCards.${index}.name`] = [requiredWhen({ when: () => model.refPersonType?.key === "2" })];
        }
    });
    // model?.attachmentSignatures?.forEach((item, index) => {
    //     if (item.isDelete !== true) {
    //         rules[`${prefix}attachmentSignatures.${index}`] = [requiredWhen({ when: () => model.refPersonType?.key === "2" })];
    //         rules[`${prefix}attachmentSignatures.${index}.name`] = [requiredWhen({ when: () => model.refPersonType?.key === "2" })];
    //     }
    // });
    return rules;
};

export const createRulesAttachment = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    if (model.refPersonType?.key === "1") {
        model?.attachments?.forEach((item, index) => {
            if (item.isDelete !== true) {
                rules[`${prefix}attachments.${index}.documentName`] = [required];
                rules[`${prefix}attachments.${index}.size`] = [
                    requiredWhen({ when: () => model.attachments[index].attribute?.isRequiredAttachment }),
                ];
            }
        });
    }
    return rules;
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = Promise.resolve({ data: [modelRef] });
    return promise
        .then((page) => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const promises = [
        callPersonType({}),
        callAddressType({}),
        callGender({}),
        callRegisterAttachment({}),
        callSameAddressType({})
    ];
    return Promise.all(promises).then((arr) => {
        data.personTypes = arr[0];
        data.addressTypes = arr[1];
        data.genderTypes = arr[2];
        data.callRegisterAttachments = arr[3];
        data.callSameAddressType = arr[4];

        modelRef.refPersonType = data.personTypes.find((d) => d.key === "2");
        modelRef.refSameAddressType = data.callSameAddressType.find((d) => d.key === "2");
        modelRef.addresses[0].refAddressType = data.addressTypes.find((d) => d.key === "1");
        modelRef.addresses[0].isValue1 = false
        modelRef.addresses[1].refAddressType = data.addressTypes.find((d) => d.key === "2");
        modelRef.refGender = data.genderTypes.find((d) => d.key === "M");

        data.addressPersonType = modelRef.addresses[0].refAddressType.value;
        data.registerAttachments = data.callRegisterAttachments;
        data.registerAttachments.forEach((item) =>
            modelRef.attachments.push({ keyAttachment: item.key, documentName: item.value, attribute: lodash.cloneDeep(item.attribute) })
        );
        modelRef.attachmentIdCards.push({})
        modelRef.attachmentSignatures.push({})
    });
};

export const initForm = ({ props, data, refs }) => {
    data.current = 0;
    data.tabkey = "UserSyndicate";
    data.registerType = "FISHERMAN";
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.attachments.filter((d) => d.isDelete !== true).length > 0,
        createRules: () => createRulesTab0({ props, data, refs }),
        itemsKey: "attachments",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.attachments.filter((d) => d.isDelete !== true).length > 0,
        createRules: () => createRulesAttachment({ props, data, refs }),
        itemsKey: "attachments",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refPersonType?.key,
        createRules: () => createRulesAttachment({ props, data, refs }),
        itemsKey: "attachments",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.addresses.filter((d) => d.isDelete !== true).length,
        createRules: () => createRulesTab0({ props, data, refs }),
        itemsKey: "addresses",
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.attachmentIdCards.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab3({ props, data, refs }),
        itemsKey: ["attachmentIdCards"]
    });
    loadForm({ props, data, refs });
};

export const onClickOpenModalOtp = ({ props, data, refs }) => {
    data.useForm
        .validate()
        .then(() => {
            openModalOtp({
                props: { dataProp: { form: { mobile: data.useForm.modelRef.mobile } } },
                onOkCallback: ({ otp, options }) => {
                    if (otp.isWaitApprove === true) {
                        otp = null;
                    }
                    onClickSave({ props, data, refs, otp, isWaitApprove: data.isWaitApprove === true ? true : null }).then(() => {
                        notification["success"]({ message: i18n.global.t("views.register.success") });
                        options.bind.onCancel();
                        options.bind.visible = false;
                    });
                },
            });
        })
        .catch((error) => {
            validateError({ error });
            throw error;
        });
};

export const nextPageChecklinkIdCardPersonType1 = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    if("wait" === data.linkIdCard) {
        return true
    } 
    return (
        data.linkIdCard?.idCard === modelRef.idCard &&
        !(
            data.linkIdCard?.companyNameTh?.indexOf(modelRef.companyNameTh) === -1 &&
            modelRef.companyNameTh.indexOf(data.linkIdCard?.companyNameTh) === -1
        ) &&
        (
            modelRef.refCompanyType?.value.indexOf(data.linkIdCard?.companyType) === -1
        )
    );
};

export const nextPageChecklinkIdCardPersonType2 = ({ data }) => {
    if("wait" === data.linkIdCard) {
        return true
    }
    return (
        data.linkIdCard?.title === true &&
        data.linkIdCard?.firstNameTh === true &&
        data.linkIdCard?.lastNameTh === true &&
        data.linkIdCard?.birthDate === true && 
        data.linkIdCard?.expireDate === true 
    );
};
